export default __webpack_public_path__ + "static/media/Arilson Lopes_.c5fdc8a0.png";